import classNames from 'classnames';
import { useMapContext } from '@/map/Map.tsx';
import { LanguageContext } from '@/common/Language.tsx';
import { useContext } from 'react';

enum ExplorationView {
  Graph = 'graph',
  Text = 'text',
}

export { ExplorationView };

export default function NewGraphSwitch({
  explorationView,
  setExplorationView,
}: {
  explorationView: ExplorationView;
  setExplorationView: (view: ExplorationView) => void;
}) {
  const { t } = useContext(LanguageContext);
  return (
    <div
      className={classNames(
        'absolute',
        'top-0',
        'left-1/2',
        '-translate-x-1/2',
        'h-12',
        'flex',
        'items-center',
        'z-10',
        'border-6',
        'border-gray-100'
      )}
    >
      <div className={classNames('flex', 'bg-gray-200', 'rounded-lg', 'p-1')}>
        <button
          className={classNames(
            'px-4',
            'py-2',
            'rounded-md',
            'text-sm',
            'font-medium',
            'transition-colors',
            'cursor-pointer',
            explorationView === ExplorationView.Graph
              ? ['bg-white', 'text-gray-900', 'shadow-sm']
              : ['text-gray-500', 'hover:text-gray-700']
          )}
          onClick={() => setExplorationView(ExplorationView.Graph)}
        >
          {t('Graph View', 'Graphen-Ansicht')}
        </button>
        <button
          className={classNames(
            'px-4',
            'py-2',
            'rounded-md',
            'text-sm',
            'font-medium',
            'transition-colors',
            'cursor-pointer',
            explorationView === ExplorationView.Text
              ? ['bg-white', 'text-gray-900', 'shadow-sm']
              : ['text-gray-500', 'hover:text-gray-700']
          )}
          onClick={() => setExplorationView(ExplorationView.Text)}
        >
          {t('List View', 'Listen-Ansicht')}
        </button>
      </div>
    </div>
  );
}
